import { ComponentFactoryResolver, ComponentRef, Injectable, Type, ViewContainerRef } from '@angular/core';

@Injectable()
export class StepperService {

  private components: Map<string, ComponentRef<any>>;

  constructor(
    private resolver: ComponentFactoryResolver) {
    this.components = new Map();
  }

  addInstance(className: string, instance: ComponentRef<any>) {
    this.components.set(className, instance);
  }

  getInstance(className: string): ComponentRef<any> {
    return this.components.get(className);
  }

  buildComponent(component: any, vcRef: ViewContainerRef): ComponentRef<any> {
    const factories = Array.from(this.resolver['_factories'].values());
    const factoryClass :any  = factories.find((x: any) => x.selector === component) as Type<any>;
    const factory = this.resolver.resolveComponentFactory(factoryClass.componentType);
    const compRef: ComponentRef<any> = vcRef.createComponent(factory);
    this.addInstance(component, compRef);
    return compRef;
  }

  clear(componentName) {
    this.components.delete(componentName);
  }
}
